import { AppointmentRepository } from '@/core/appointment/domain/AppointmentRepository.ts'
import { EditAppointmentRequest } from '@/core/appointment/domain/Appointment.ts'

type EditAppointmentUseCaseDependencies = { appointmentRepository: AppointmentRepository }

export class EditAppointmentUseCase {
  private readonly appointmentRepository: AppointmentRepository
  constructor({ appointmentRepository }: EditAppointmentUseCaseDependencies) {
    this.appointmentRepository = appointmentRepository
  }

  execute = (request: EditAppointmentRequest): Promise<void> => {
    return this.appointmentRepository.editAppointment(request)
  }
}
